<div class="item">
  <header class="item__header">
    <div class="item__img-wrapper">
      <a
        class="item__img-container"
        [routerLink]="'/' + item().slug"
        routerLinkWithLang
        [class.item__img-container--with-hover]="item().mediaHoverUrl"
      >
        <img class="item__img item__img-primary"
          [src]="setItemThumbnail()"
          [alt]="item().mediaAltText"
          loading="lazy"
        >

          @if (item().mediaHoverUrl) {
            <img class="item__img item__img-secondary"
              [src]="uploadedHost + item().mediaHoverUrl"
              [alt]="item().mediaAltText"
              loading="lazy"
            >
          }

          @if (item().label) {
            <span class="item__label" [ngClass]="getLabelClass()">
              {{ item().label.text }}
            </span>
          }

          @if (item().oldPrice) {
            <span class="item__sale-label"
              >
              -{{ discountValue }}%
            </span>
          }

        </a>
        @if (isLoggedIn && item().isInWishlist === false) {
          <button class="item__wishlist" (click)="toggleWishlistFlag()">
            <i class="mbi mbi-heart item__wishlist-icon"></i>
          </button>
        }

        @if (isLoggedIn && item().isInWishlist === true) {
          <button class="item__wishlist" (click)="toggleWishlistFlag()">
            <svg class="item__wishlist-icon-fill" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
              fill="currentColor" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
            </svg>
          </button>
        }

        @if (!isLoggedIn) {
          <button class="item__wishlist" (click)="suggestToLogin()">
            <i class="mbi mbi-heart item__wishlist-icon"></i>
          </button>
        }

      </div>
      <h2 class="item__name">
        <a class="main-link main-link--black" [routerLink]="'/' + item().slug" routerLinkWithLang>{{ item().name }}</a>
      </h2>
    </header>

    @if (item().variantGroups?.length) {
      <product-variants class="item__variants"
        [variantGroups]="item().variantGroups"
      ></product-variants>
    }

    @if (item().reviewsInfo.allReviewsCount > 0) {
      <a
        class="item__rating"
        [routerLink]="'/' + item().slug"
        routerLinkWithLang
        fragment="reviews"
        >
        <rating-stars class="item__rating-cmp"
          [rating]="item().reviewsInfo.avgRating"
          [isDisabled]="true"
          [isSmall]="true"
        ></rating-stars>
        <span class="item__rating-count">{{ item().reviewsInfo.allReviewsCount }}</span>
      </a>
    }

    @if (!item().reviewsInfo.allReviewsCount) {
      <div class="item__rating-placeholder"></div>
    }

    @if (error; as error) {
      <div class="item__error">
        {{ error }}
      </div>
    }

    <div class="item__info">
      <div class="item__price-container">
        <div class="item__price"
          [class.item__price--special]="item().oldPrice"
          [class.item__price--inactive-small]="activePriceIndex !== undefined"
          >
          @if (item().isAggregator) {
            <span class="item__from">
              {{ 'global.from' | translate }}
            </span>
          }
          {{ item().price }}
          <span class="item__currency">
            {{ 'global.uah' | translate }}
          </span>
        </div>

        @if (item().oldPrice; as oldPrice) {
          <div class="item__old-price">
            @if (item().isAggregator) {
              <span>
                {{ 'global.from' | translate }}
              </span>
              } {{ oldPrice }}
              <span class="item__currency">{{ 'global.uah' | translate }}
              </span>
            </div>
          }
        </div>

        <div class="item__actions">
          @if (item().isAggregator) {
            <a
              class="btn item__buy item__buy--aggregator"
              [routerLink]="'/' + item().slug"
              routerLinkWithLang
              fragment="details"
              >
              {{ 'product_list_item.more' | translate }}
            </a>
          } @else {
            @if (item().isInStock) {
              <button class="btn item__buy"
                [class.item__buy--loading]="isLoading"
                [disabled]="isLoading"
                (click)="addToCart()"
                >
                <i class="mbi mbi-cart item__buy-icon"></i>
                {{ 'global.to_buy' | translate }}
                @if (isLoading) {
                  <preloader class="item__preloader"></preloader>
                }
              </button>
            } @else {
              <span class="item__out-of-stock">
                {{ 'global.out_of_stock' | translate }}
              </span>
            }
          }


        </div>
      </div>

      @if (!item().oldPrice) {
        <ul class="item__discount-price-container discount">
          @for (price of item().discountedPrices; track price; let i = $index) {
            <li class="discount__item">
              <div class="discount__price" [ngClass]="i === activePriceIndex ? 'discount__price--active' : ''">
                @if (item().isAggregator) {
                  <span class="discount__from">{{ 'global.from' | translate }}</span>
                }
                {{ price.price }} <span class="item__currency">{{ 'global.uah' | translate }}</span>
              </div>
              <div class="discount__info">
                <i class="discount__icon mbi mbi-cart"></i>
                <span class="discount__from">{{ 'global.from' | translate }}</span>
                <div class="discount__breakpoint">
                  {{ price.costBreakpoint }} <span class="discount__currency">{{ 'global.uah' | translate }}</span>
                </div>
              </div>
            </li>
          }
        </ul>
      }
    </div>
